module.exports = __webpack_public_path__ + "static/media/bind.538f8a4a.png";